import { __rest, __assign } from '../../_virtual/_tslib.js';
import React from 'react';
import classnames from 'classnames';
import CuratedIconMark from './curated-iconmark.svg.js';
import CuratedWordmark from './curated-wordmark.svg.js';
import CuratedCombomark from './curated-combomark.svg.js';
import styles from './styles.css.js';

var Logo = function Logo(_a) {
  var _b = _a.color,
      color = _b === void 0 ? 'inherit' : _b,
      _c = _a.mark,
      mark = _c === void 0 ? 'word' : _c,
      className = _a.className,
      rest = __rest(_a, ["color", "mark", "className"]);

  var props = __assign({
    className: classnames(styles[color], className)
  }, rest);

  switch (mark) {
    case 'combo':
      return React.createElement(CuratedCombomark, __assign({}, props));

    case 'icon':
      return React.createElement(CuratedIconMark, __assign({}, props));

    default:
      return React.createElement(CuratedWordmark, __assign({}, props));
  }
};

export default Logo;
//# sourceMappingURL=index.js.map
